import Vue from 'vue'
import gql from '../graphql/apollo.js'
import axios from 'axios'
import qs from 'qs'
import store from '../../store/index'
(function(window){
	var api={
		option:{
			start:0,
			limit:3,
			total:0,
			robotName:"服务大厅智能助手",
			robotImage:"",
			historyStart:0,
			historyLimit:10,
			historyTotal:0,
			apiCommon:window.commonApi.KNOWLEDGE_BOT_URL,
			apiBeta:window.commonApi.BOT_URL
		},
		createRobot:function(){
//				获取机器人信息
			this.getRobotInfo();
		},
		//在页面上显示aibutton
		showButton:function(){
			var aiDialog_container=document.getElementsByClassName("aiDialog_container");
			if(aiDialog_container.length==0){
				//添加整体结构
				var aiDialog_container=document.createElement("div");
				aiDialog_container.className="aiDialog_container";
				document.body.appendChild(aiDialog_container);
				var aiDialog_content="<div>"+
											"<div class='aiDialog_body' id='robot'>"+
												"<div class='aiDialog_top'>服务大厅智能助手<span class='aiDialog_toSmall'></span><div class='scales'><span id='lessSize'>-</span><span id='moreSize'>+</span></div></div>"+
												"<div class='aiDialog_center'>"+
													"<div class='aiMessageList'>"+
														"<div class='toGetHistory'><span class='aiDialog_loading_img'></span><span class='aiDialog_loading_text'>查看更多历史</span></div>"+
														"<div class='historyContainer'></div>"+
													"</div>"+
												"</div>"+
												"<div class='aiDialog_bottom'>"+
													"<ul class='aiDialog_tool'>"+
														"<li class='aiDialog_tool_close'>取消</li>"+
														"<li class='aiDialog_tool_send'>发送</li>"+
														"<li class='aiDialog_tool_yy' title='请点击进行录音'></li>"+
													"</ul>"+
													"<textarea class='aiDialog_textarea' placeHolder='请输入内容...'></textarea>"+
													"<div class='aiDialog_yy_container'>"+
														"<p class='aiDialog_yy_text'>录音文字是录音文字是录音文字是</p>"+
														"<button class='aiDialog_recordering'><div class='aiDialog_recordering_inner'></div></button>"+
													"</div>"+
												"</div>"+
											"</div>"+
											"<div class='aiDialog_button'>"+
												"<div class='aiDialog_tip'></div>"+
												"<div class='aiDialog_btn_img'></div>"+
											"</div>"+
										"</div>";
				aiDialog_container.innerHTML=aiDialog_content;
				var aiDialog_btn_img=document.getElementsByClassName("aiDialog_btn_img")[0];
				if(this.option.robotImage){
					aiDialog_btn_img.style.backgroundImage = "url("+this.option.robotImage+")";
				}
				var aiDialog_body=document.getElementsByClassName("aiDialog_body")[0];
				aiDialog_btn_img.onclick=function(){
					if(localStorage.getItem("aiDialogOpen") === 'true'){
						aiDialog_body.classList.remove("showaiDialog");
						localStorage.setItem("aiDialogOpen",false);
					}else{
					
						var aiDialog_tip=document.getElementsByClassName("aiDialog_tip")[0];
						aiDialog_tip.classList.add("aiDialog_hideTip");
						aiDialog_body.classList.add("showaiDialog");
						//dialog打开，存localStorage
						localStorage.setItem("aiDialogOpen",true);
					}
				}
				var moreSize = document.getElementById('moreSize');
				var lessSize = document.getElementById('lessSize');
				localStorage.setItem("robotSize",1);
				moreSize.onclick = function(){
					var robot = document.getElementById('robot');
					var size = Number(localStorage.getItem("robotSize"))+0.1
					robot.style['transform'] = 'scale('+size+')';
					console.log(size);
					localStorage.setItem("robotSize",size);
				}
				lessSize.onclick = function(){
					var robot = document.getElementById('robot');
					var size = Number(localStorage.getItem("robotSize"))-0.1
					robot.style['transform'] = 'scale('+size+')';
					console.log(size);
					localStorage.setItem("robotSize",size);
				}
				
				var aiDialog_toSmall=document.getElementsByClassName("aiDialog_toSmall")[0];
				aiDialog_toSmall.onclick=function(){
					aiDialog_body.classList.remove("showaiDialog");
					localStorage.setItem("aiDialogOpen",false);
				}
				var that=this;
				var aiDialog_textarea = document.getElementsByClassName("aiDialog_textarea")[0];
				aiDialog_textarea.onkeydown=function(event) {
			        if(event.keyCode == 13) {
						event.preventDefault();
			            that.sendMessage();
			        }
				}
				// 语音
				var aiDialog_tool_yy = document.getElementsByClassName("aiDialog_tool_yy")[0];
				aiDialog_tool_yy.onclick=function(){
					aiDialog_body.classList.add("aiDialog_show_yy");
					setTimeout(function(){
						var aiDialog_center=document.getElementsByClassName("aiDialog_center")[0];
						aiDialog_center.scrollTop = aiDialog_center.scrollHeight;
					},600)
					//开始录音
					that.startRecording();
				}
				//关闭 关闭的时候若是有语音中文，就填入输入框，但不发送
				var aiDialog_tool_close=document.getElementsByClassName("aiDialog_tool_close")[0];
				aiDialog_tool_close.onclick=function(){
					var message=document.getElementsByClassName("aiDialog_yy_text")[0].innerHTML;
					if(message){
						aiDialog_textarea.value=message;
					}
					aiDialog_body.classList.remove("aiDialog_show_yy");
					that.stopRecording();
				}
				//发送
				var aiDialog_tool_send=document.getElementsByClassName("aiDialog_tool_send")[0];
				aiDialog_tool_send.onclick=function(){
					var message=document.getElementsByClassName("aiDialog_yy_text")[0].innerHTML;
					that.sendMessage(message);
					aiDialog_body.classList.remove("aiDialog_show_yy");
					that.stopRecording();
				}

				//获取历史
				var toGetHistory = document.getElementsByClassName("toGetHistory")[0];
				toGetHistory.onclick=function(){
					that.getHistory();
				}
//				添加滚动事件
				var aiDialog_center=document.getElementsByClassName("aiDialog_center")[0];
				var aiDialog_loading_img=document.getElementsByClassName("aiDialog_loading_img")[0];
				var aiDialog_loading_text=document.getElementsByClassName("aiDialog_loading_text")[0];
				aiDialog_center.addEventListener("scroll", function () {
			        var scrollTop=aiDialog_center.scrollTop;
			        if(scrollTop==0){
			        	that.option.historyStart=that.option.historyStart+that.option.historyLimit;
			        	if(that.option.historyStart<(that.option.historyTotal-1)){
			        		aiDialog_loading_img.classList.add("showLoading");
			        		that.getHistory();
			        	}else{
			        		aiDialog_loading_text.innerHTML="没有更多了"
			        	}
			        }
			    })
				var message="你好，我是"+this.option.robotName+",有什么可以帮到您吗？";
				var parent=document.getElementsByClassName("aiMessageList")[0];
				this.getSystemMessage(parent,message);
				//添加推荐
				this.getRecommend();
				//添加互动
				this.addTip();

				//添加拖拽功能
				this.addTake();
				
			}
		},
		addTake:function(){
			//获取元素
			var dv = document.getElementById('robot');
			var x = 0;
			var y = 0;
			var l = 0;
			var t = 0;
			var isDown = false;
			//鼠标按下事件
			dv.onmousedown = function(e) {
				//获取x坐标和y坐标
				x = e.clientX;
				y = e.clientY;

				//获取左部和顶部的偏移量
				l = dv.offsetLeft;
				t = dv.offsetTop;
				//开关打开
				isDown = true;
				//设置样式  
				dv.style.cursor = 'move';
				dv.classList.add('mask');
			}
			//鼠标移动
			window.onmousemove = function(e) {
				if (isDown == false) {
					return;
				}
				//获取x和y
				var nx = e.clientX;
				var ny = e.clientY;
				//计算移动后的左偏移量和顶部的偏移量
				var nl = nx - (x - l) + 10;
				var nt = ny - (y - t) + 500;

				dv.style.left = nl + 'px';
				dv.style.top = nt + 'px';
			}
			//鼠标抬起事件
			dv.onmouseup = function() {
				//开关关闭
				isDown = false;
				dv.style.cursor = 'default';

				dv.classList.remove('mask');
			}
		},
		addTip:function(){
			var aiDialog_tip_html="<p>我是你的<span>智能助手，可随时询问我哦~</span></p>"+
									"<p>"+
										"<a href='javascript:;' class='aiDialog_toOpen'>立即咨询</a>"+
										"<a href='javascript:;' class='aiDialog_next'>下次再说</a>"+
									"</p>";
			var aiDialog_tip=document.getElementsByClassName("aiDialog_tip")[0];
//			根据缓存考虑dialog的显示和tip的显示
			var aiDialogOpen=localStorage.getItem("aiDialogOpen");
			if(aiDialogOpen=="true"){
				var aiDialog_body=document.getElementsByClassName("aiDialog_body")[0];
				aiDialog_body.classList.add("showaiDialog");
				aiDialog_tip.classList.add("aiDialog_hideTip");
			}
			aiDialog_tip.innerHTML=aiDialog_tip_html;
			var aiDialog_toOpen=aiDialog_tip.getElementsByClassName("aiDialog_toOpen")[0];
			var aiDialog_next=aiDialog_tip.getElementsByClassName("aiDialog_next")[0];
			aiDialog_toOpen.onclick=function(event){
				aiDialog_tip.classList.add("aiDialog_hideTip");
				var aiDialog_body=document.getElementsByClassName("aiDialog_body")[0];
				aiDialog_body.classList.add("showaiDialog");
			}
			aiDialog_next.onclick=function(){
				aiDialog_tip.classList.add("aiDialog_hideTip");
			}
		},
		//发送消息
		sendMessage:function(ms){
			var that=this;
			//发送消息
			var writeMessageDom=document.getElementsByClassName("aiDialog_textarea")[0];
			if(ms){
				writeMessageDom.value=ms;
			}
			var writeMessage=writeMessageDom.value;
			writeMessageDom.value="";
			if(writeMessage){
				var parent=document.getElementsByClassName("aiMessageList")[0];
				this.setMessage(parent,writeMessage);
				var json={};
		        json.ques= writeMessage;
		        json.schoolId= 'test';
		        json.channel= 'web';
				axios({
					method: "POST",
					url: that.option.apiCommon+that.option.apiBeta+"/webQa",
					headers:{
						'Content-Type':'application/json;charset=UTF-8'
					},
					dataType:"json",
					data: JSON.stringify(json)
				}).then(response => {
					if(response.status==200){
						var message=response.data.t;
						that.getSystemMessage(parent,message);
						var aiDialog_center=document.getElementsByClassName("aiDialog_center")[0];
						aiDialog_center.scrollTop = aiDialog_center.scrollHeight;
					}
				}).catch(error => {
					console.log(error); //请求失败返回的数据
				});
			}
			
		},
		setMessage:function(parent,message,createTime){
			var myLi=document.createElement("li");
			myLi.classList.add("aiDialog_my_message");
			parent.appendChild(myLi);
			if(createTime){
				var nowTime=this.getTime(createTime);
			}else{
				var nowTime=this.getTime();
			}
			var li_html="<p class='aiDialog_time'>"+nowTime+"</p>"+
						"<div class='aiDialog_my_message_content'>"+message+"<span class='aiDialog_jt'></span></div>";
			myLi.innerHTML=li_html;
			var aiDialog_center=document.getElementsByClassName("aiDialog_center")[0];
			aiDialog_center.scrollTop = aiDialog_center.scrollHeight;
		},
		getSystemMessage:function(parent,message,createTime){
			var that=this;
			var myLi=document.createElement("li");
			myLi.classList.add("aiDialog_system_message");
			parent.appendChild(myLi);
			if(createTime){
				var nowTime=this.getTime(createTime);
			}else{
				var nowTime=this.getTime();
			}
			
			var li_html="<span class='aiDialog_system_image'></span>"+
						"<p class='aiDialog_time'>"+nowTime+"</p>"+
						"<div class='aiDialog_system_message_content'>"+message+"<span class='aiDialog_open_later'></span><span class='aiDialog_jt'></span></div>";
			myLi.innerHTML=li_html;
			var aiDialog_system_message_content=myLi.getElementsByClassName("aiDialog_system_message_content")[0];
			//无论a标签是否是在target，都在新页面打开
			var as=aiDialog_system_message_content.getElementsByTagName("a");
			if(as.length>0){
				for(var i=0;i<as.length;i++){
					var operation=as[i].getAttribute("data-operation");
					if(operation==null||operation.indexOf("open(")>-1){
						var a_href=as[i].getAttribute("href");
						as[i].setAttribute("href","javascript:;");
						as[i].setAttribute("data-url",a_href);
						as[i].onclick=function(event){
							event.preventDefault();
							var href=this.getAttribute("data-url");
							window.open(href);
						}
					}else if(operation=="reply"){
						as[i].setAttribute("href","javascript:;");
						as[i].onclick=function(event){
							var ms=this.innerText;
							that.sendMessage(ms);
						}
					}	
				}
			}
			//历史数据不做自动打开
			var parentClass=parent.className;
			if(parentClass.indexOf("aiDialog_history_splice")<0){
				//判断data-operation是否含有open参数，参数大于0显示倒计时，其他时候不做处理；
				if(message.indexOf('data-operation="open(')>-1){
					var messageA=this.parseDom(message);
					var operation=messageA[0].getAttribute("data-operation");
					var num=parseInt(operation.match(/\((\S*)\)/)[1]);
					//倒计时打开
					if(num>0){
						this.countDown(aiDialog_system_message_content,num);
					}
				}
			}
			
			if(this.option.robotImage){
				var aiDialog_system_image=myLi.getElementsByClassName("aiDialog_system_image")[0];
				aiDialog_system_image.style.backgroundImage="url("+this.option.robotImage+")";
			}
		},
		countDown:function(myContent,num){
			var openLater="<span class='aiDialog_open_num'>"+num+"</span>秒后为您打开";
			var aiDialog_open_later=myContent.getElementsByClassName("aiDialog_open_later")[0];
			aiDialog_open_later.innerHTML=openLater;
			var spanNum=myContent.getElementsByClassName("aiDialog_open_num")[0]; 
			var timeInterval=null;
			timeInterval=setInterval(function(){
				num--;
				spanNum.innerHTML=num;
				if(num==0){
					var as=myContent.getElementsByTagName("a");
					if(as.length>0){
						as[0].click();
					}
					aiDialog_open_later.innerHTML="";
					clearInterval(timeInterval);
				}
			},1000)
		},
		parseDom:function(arg) {
		　　 var objE = document.createElement("div");
		　　 objE.innerHTML = arg;
		　　 return objE.childNodes;
		},
		recorder:null,
		startRecording:function() {
			var that=this;
			that.yyPageReset(true);
            window.Recorder.get(function (rec) {
                that.recorder = rec;
                that.recorder.start();
            });
        },
        stopRecording:function(){
			var that=this;
			for(var i=0;i<this.pending.length;i++){
				this.pending[i].f();
			}
			this.pending=[];
			this.nowOrder=0;
			that.recorder.stop();
		},
		yyPageReset:function(isStart,message){
			var that=this;
			var aiDialog_recordering=document.getElementsByClassName("aiDialog_recordering")[0];
			aiDialog_recordering.classList.remove("aiDialog_yy_again");
			var aiDialog_yy_text=document.getElementsByClassName("aiDialog_yy_text")[0];
			if(isStart==true){
				aiDialog_yy_text.innerHTML="";
			}else{
				if(message){
					aiDialog_yy_text.innerHTML=message;
				}else{
					// aiDialog_yy_text.innerHTML="不好意思，我不太理解您的意思!";
					// that.isSearch=false;
					// that.stopRecording();
					// var aiDialog_recordering=document.getElementsByClassName("aiDialog_recordering")[0];
					// aiDialog_recordering.classList.add("aiDialog_yy_again");
				}
			}
		},
		pending:[],//语音停止的时候去终止未完成的请求
		nowOrder:0,
		voiceToText:function(data){
			var order=this.pending.length+1;
			data.set('order', order);
			var that=this;
			var cancelToken = axios.CancelToken;
			axios({
				method: "POST",
				url:window.aiDialog.option.apiCommon+that.option.apiBeta+"/asr",
				cancelToken:new cancelToken((c)=>{
					that.pending.push({f: c });  
				}),
				data: data
			}).then(response => {
				if(response.status==200){
					var order=response.data.t.order;
					if(order>that.nowOrder){
						window.aiDialog.yyPageReset(false,response.data.t.text);
					}
					
				}
			}).catch(error => {
				console.log(error); //请求失败返回的数据
			});
		},

		showImageData(data){
			fr.readAsDataURL(this.dataURLToBlob(data));
			return fr.result;
		},
		dataURLToBlob(dataurl) {
			var arr = dataurl.split(',')
			var mime = arr[0].match(/:(.*?);/)[1]
			var bstr = atob(arr[1])
			var n = bstr.length
			var u8arr = new Uint8Array(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], { type: mime })
		},
		getRobotInfo:function(){
			var that=this;
			var vm = new Vue({
				provide: window.apolloProvider.provide()
			});
			vm.$apollo.query({
			  	query: gql.list,
			  	variables: {
				},
				client: 'api'
		 	})
		 	.then(response => {
		 		var data=response.data.robotInfos.edges[0].node
		 		if(data.image){
		 			that.option.robotImage=data.image;
		 		}
		 		if(data.name){
		 			that.option.robotName=data.name;
		 		}
		 		that.showButton();
		 	})
		 	.catch(error => {
		 	})
		},
		getHistory:function(){
			var that=this;
			var userId=store.state.oidcStore.user.account;
			var userName=store.state.oidcStore.user.name;
			var vm = new Vue({
				provide: window.apolloProvider.provide()
			});
			vm.$apollo.query({
			  	query: gql.qa,
			  	variables: {
			    	start:that.option.historyStart,
			    	limit:that.option.historyLimit,
					userId:userId,
					channel:"web"
				},
				client: 'api'
		 	})
		 	.then(response => {
		 		var edges=response.data.qaRecords.edges;
		 		var aiDialog_loading_img=document.getElementsByClassName("aiDialog_loading_img")[0];
				var aiDialog_loading_text=document.getElementsByClassName("aiDialog_loading_text")[0];
		 		aiDialog_loading_img.classList.remove("showLoading");
		 		if(edges.length==0){
					aiDialog_loading_text.innerHTML="没有更多了";
		 		}
		 		that.option.historyTotal=response.data.qaRecords.totalCount;
		 		var parent=document.getElementsByClassName("historyContainer")[0];
		 		var aiDialog_history_splice=document.getElementsByClassName("aiDialog_history_splice");
		 		if(aiDialog_history_splice.length==0){
		 			var div_splice=document.createElement("div");
		 			div_splice.className="aiDialog_history_splice";
		 			parent.append(div_splice);
		 		}else{
		 			var div_splice=document.createElement("div");
		 			div_splice.className="aiDialog_history_splice";
		 			parent.insertBefore(div_splice,aiDialog_history_splice[0]);
		 		}
		   		for(var i=edges.length-1;i>=0;i--){
		   			that.setMessage(div_splice,edges[i].node.question,edges[i].node.createTime);
		   			that.getSystemMessage(div_splice,edges[i].node.answer,edges[i].node.createTime);
		   		}
		   		var aiDialog_history_splice=document.getElementsByClassName("aiDialog_history_splice")[0];
		   		var offsetTop=aiDialog_history_splice.offsetTop+aiDialog_history_splice.clientHeight;
		   		var aiDialog_center=document.getElementsByClassName("aiDialog_center")[0];
			    aiDialog_center.scrollTop = offsetTop;
		 	})
		 	.catch(error => {
		 	})
		},
		getRecommend:function(){
			var that=this;
			var vm = new Vue({
				provide: window.apolloProvider.provide()
			});
			vm.$apollo.query({
			  	query: gql.findList,
			  	variables: {
			    	start:that.option.start,
			    	limit:that.option.limit,
			    	status:1,
			    	recommStatus:1,
			    	isRandom:true,
			    	similar:false
				},
				client: 'api'
		 	})
		 	.then(response => {
		 		var data=response.data.standardQuestions.edges;
		 		that.option.total=response.data.standardQuestions.totalCount;
		   		that.createRecommend(data);
		 	})
		 	.catch(error => {
		 	})
		},
		createRecommend:function(data){
			var that=this;
			var aiMessageList=document.getElementsByClassName("aiMessageList")[0];
			var recommendContainer=document.getElementsByClassName("recommendContainer");
			if(recommendContainer.length==0){
				var recommendContent=document.createElement("div");
				recommendContent.classList.add("recommendContainer");
				var recommendContentHtml="<div class='recommendContentList'></div>"+
								 		"<div class='recommendContentHyp'>换一批</div>";
				recommendContent.innerHTML=recommendContentHtml
				aiMessageList.appendChild(recommendContent);			 
			}
			var recommedHyp=document.getElementsByClassName("recommendContentHyp")[0];
			recommedHyp.onclick=function(){
				that.option.start=that.option.start+that.option.limit;
				if(that.option.start>=that.option.total){
					that.option.start=0;
				}
				that.getRecommend();
			}
			var recommendContentList=document.getElementsByClassName("recommendContentList")[0];
			recommendContentList.innerHTML="";
			for(var i=0;i<data.length;i++){
				var recommendP=document.createElement("p");
				recommendContentList.appendChild(recommendP);
				recommendP.className="recommendP";
				recommendP.innerHTML="<span class='wz'>"+data[i].node.question+"</span>";
				recommendP.onclick=function(){
					var ms=this.getElementsByClassName("wz")[0].innerHTML;
					that.sendMessage(ms);
				}
			}
			
		},
		getTime:function(date){
			if(!date){
				date=new Date(); 
			}else{
				date=new Date(date);
			}
			var year=date.getFullYear();
			var month=date.getMonth()+1;
			var day = date.getDate();
			var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
			var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
			var second = date.getSeconds() < 10 ? '0' +date.getSeconds() : date.getSeconds();
			var curTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + second;
			return curTime;
		},
		//原生js调接口封装
		ajax:function(){ 
  			var ajaxData = { 
    			type: (arguments[0].type || "GET").toUpperCase(), 
    			url: arguments[0].url || "", 
    			async: arguments[0].async || "true", 
    			data: arguments[0].data || null, 
    			dataType: arguments[0].dataType || "json", 
    			contentType: arguments[0].contentType || "application/x-www-form-urlencoded; charset=utf-8", 
    			beforeSend: arguments[0].beforeSend || function(){}, 
    			success: arguments[0].success || function(){}, 
    			error: arguments[0].error || function(){} 
  			} 

  			ajaxData.beforeSend() 
  			var xhr = this.createxmlHttpRequest();  
  			xhr.responseType=ajaxData.dataType; 

  			xhr.open(ajaxData.type,ajaxData.url,ajaxData.async);  
  			xhr.setRequestHeader("Content-Type",ajaxData.contentType);  
  			xhr.send(this.convertData(ajaxData.data));  

  			xhr.onreadystatechange = function() {  
    			if (xhr.readyState == 4) {  
      				if(xhr.status == 200){ 
        				ajaxData.success(xhr.response) 
      				}else{ 
        				ajaxData.error() 
      				}  
    			} 
  			}
		}, 
		createxmlHttpRequest:function() {  
  			if (window.ActiveXObject) {  
    			return new ActiveXObject("Microsoft.XMLHTTP");  
  			} else if (window.XMLHttpRequest) {  
    			return new XMLHttpRequest();  
  			}  
		},
		convertData:function(data){ 
  			if( typeof data === 'object' ){ 
    			var convertResult = "" ;  
    			for(var c in data){  
      				convertResult+= c + "=" + data[c] + "&";  
    			}  
    			convertResult=convertResult.substring(0,convertResult.length-1) 
   	 			return convertResult; 
  			}else{ 
	    		return data; 
	  		} 
		}
	}
	window.aiDialog=api;
})(window);

//语音
(function (window) {  
    //兼容  
    window.URL = window.URL || window.webkitURL;  
    //请求麦克风
    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;  
  
    var Recorder = function (stream, config) {  
        //创建一个音频环境对象  
        var audioContext = window.AudioContext || window.webkitAudioContext;  
        var context = new audioContext();  
        
        config = config || {};  
        config.channelCount = 1;
        config.numberOfInputChannels = config.channelCount;
        config.numberOfOutputChannels = config.channelCount;
        config.sampleBits = config.sampleBits || 16;      //采样数位 8, 16  
        //config.sampleRate = config.sampleRate || (context.sampleRate / 6);   //采样率(1/6 44100)
        config.sampleRate = config.sampleRate || 8000;   //采样率16K
        //创建缓存，用来缓存声音  
        config.bufferSize = 4096;
        
        //将声音输入这个对像  
        var audioInput = context.createMediaStreamSource(stream);  
          
        //设置音量节点  
        var volume = context.createGain();
        audioInput.connect(volume);  
  
        // 创建声音的缓存节点，createScriptProcessor方法的  
        // 第二个和第三个参数指的是输入和输出都是声道数。
        var recorder = context.createScriptProcessor(config.bufferSize, config.channelCount, config.channelCount); 
         
        //用来储存读出的麦克风数据，和压缩这些数据，将这些数据转换为WAV文件的格式
        var audioData = {  
            size: 0          //录音文件长度  
            , buffer: []     //录音缓存  
            , inputSampleRate: context.sampleRate    //输入采样率  
            , inputSampleBits: 16                    //输入采样数位 8, 16  
            , outputSampleRate: config.sampleRate    //输出采样率  
            , oututSampleBits: config.sampleBits     //输出采样数位 8, 16  
            , input: function (data) {  
				this.buffer.push(new Float32Array(data));  //Float32Array
				// console.log(this.buffer);
                this.size += data.length;  
            }  
            , getRawData: function () { //合并压缩  
                //合并  
                var data = new Float32Array(this.size);  
                var offset = 0;  
                for (var i = 0; i < this.buffer.length; i++) {
                    data.set(this.buffer[i], offset);  
                    offset += this.buffer[i].length;  
				}
                //压缩
                var getRawDataion = parseInt(this.inputSampleRate / this.outputSampleRate);  
                var length = data.length / getRawDataion;  
                var result = new Float32Array(length);  
                var index = 0, j = 0;  
                while (index < length) {  
                    result[index] = data[j];  
                    j += getRawDataion;  
                    index++;  
                }  
                return result;
            }             
            ,getFullWavData: function(){
              var sampleRate = Math.min(this.inputSampleRate, this.outputSampleRate);  
              var sampleBits = Math.min(this.inputSampleBits, this.oututSampleBits);  
              var bytes = this.getRawData();  
              var dataLength = bytes.length * (sampleBits / 8);  
              var buffer = new ArrayBuffer(44 + dataLength);  
              var data = new DataView(buffer);  
              var offset = 0;  
              var writeString = function (str) {  
                for (var i = 0; i < str.length; i++) {  
                    data.setUint8(offset + i, str.charCodeAt(i));  
                }  
              };  
              // 资源交换文件标识符   
              writeString('RIFF'); offset += 4;  
              // 下个地址开始到文件尾总字节数,即文件大小-8   
              data.setUint32(offset, 36 + dataLength, true); offset += 4;  
              // WAV文件标志  
              writeString('WAVE'); offset += 4;  
              // 波形格式标志   
              writeString('fmt '); offset += 4;  
              // 过滤字节,一般为 0x10 = 16   
              data.setUint32(offset, 16, true); offset += 4;  
              // 格式类别 (PCM形式采样数据)   
              data.setUint16(offset, 1, true); offset += 2;  
              // 通道数   
              data.setUint16(offset, config.channelCount, true); offset += 2;  
              // 采样率,每秒样本数,表示每个通道的播放速度   
              data.setUint32(offset, sampleRate, true); offset += 4;  
              // 波形数据传输率 (每秒平均字节数) 单声道×每秒数据位数×每样本数据位/8   
              data.setUint32(offset, config.channelCount * sampleRate * (sampleBits / 8), true); offset += 4;  
              // 快数据调整数 采样一次占用字节数 单声道×每样本的数据位数/8   
              data.setUint16(offset, config.channelCount * (sampleBits / 8), true); offset += 2;  
              // 每样本数据位数   
              data.setUint16(offset, sampleBits, true); offset += 2;  
              // 数据标识符   
              writeString('data'); offset += 4;  
              // 采样数据总数,即数据总大小-44   
              data.setUint32(offset, dataLength, true); offset += 4; 
              // 写入采样数据   
              data = this.reshapeWavData(sampleBits, offset, bytes, data);
//                var wavd = new Int8Array(data.buffer.byteLength);
//                var pos = 0;
//                for (var i = 0; i < data.buffer.byteLength; i++, pos++) {
//                    wavd[i] = data.getInt8(pos);
//                }                
//                return wavd;


              return new Blob([data], { type: 'audio/mp3' });
                   
            }
            ,closeContext:function(){
                context.close();   //关闭AudioContext否则录音多次会报错。
            }
            ,getPureWavData: function(offset) {
                var sampleBits = Math.min(this.inputSampleBits, this.oututSampleBits)
                var bytes = this.getRawData();  
                var dataLength = bytes.length * (sampleBits / 8);  
                var buffer = new ArrayBuffer(dataLength);  
                var data = new DataView(buffer);
				data = this.reshapeWavData(sampleBits, offset, bytes, data);  ;              
//                var wavd = new Int8Array(data.buffer.byteLength);
//                var pos = 0;
//                for (var i = 0; i < data.buffer.byteLength; i++, pos++) {
//                    wavd[i] = data.getInt8(pos);
//                }                
//                return wavd;
                  return new Blob([data], { type: 'audio/mp3' });


            }            
            ,reshapeWavData: function(sampleBits, offset, iBytes, oData) {
                if (sampleBits === 8) {  
                    for (var i = 0; i < iBytes.length; i++, offset++) {  
                        var s = Math.max(-1, Math.min(1, iBytes[i]));  
                        var val = s < 0 ? s * 0x8000 : s * 0x7FFF;  
                        val = parseInt(255 / (65535 / (val + 32768)));  
                        oData.setInt8(offset, val, true);  
                    }  
                } else {  
                    for (var i = 0; i < iBytes.length; i++, offset += 2) {  
                        var s = Math.max(-1, Math.min(1, iBytes[i]));  
                        oData.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);  
                    }  
                } 
                return oData;
            }
        };  
		var $change=document.getElementsByClassName("aiDialog_recordering_inner")[0];
		var height=38;
		var that=this;
		var timeStamp=(new Date()).getTime();
        //开始录音  
        this.start = function () {
			timeStamp=(new Date()).getTime();
            audioInput.connect(recorder);  
            recorder.connect(context.destination);
        };  
  
        //停止  
        this.stop = function () {
			$change.style.height=0;  
            recorder.disconnect();             
        };  
  
        //获取音频文件  
        this.getBlob = function () {  
            this.stop();  
            return audioData.getFullWavData();  
        };  
  
        //回放  
        this.play = function (audio) {  
            audio.src = window.URL.createObjectURL(this.getBlob());  
            audio.onended = function() {
                $('#play').text("Play");
            };
        };  
        
        //停止播放
        this.stopPlay=function(audio){
            audio.pause();
        }

        this.close=function(){
            audioData.closeContext();
        }

        this.trans = function (callback) {
			var fd = new FormData();
			var buffer = audioData.getPureWavData(0);         
            fd.set('file', buffer);
			callback(fd);
        };
        
		
        //音频采集  
        recorder.onaudioprocess = function (e) {
            audioData.input(e.inputBuffer.getChannelData(0));
           //获取输入和输出的数据缓冲区
			var input = e.inputBuffer.getChannelData(0);
           //绘制条形波动图
           for(var i=0;i<height;i++){
			  var changeHeight=Math.abs(height/2*input[input.length*i/height|0]);
              $change.style.height=changeHeight*30+"px";
		   }
		   //实时的去查询语音
		   var nowTime=(new Date()).getTime();
		   if(nowTime-timeStamp>500){
				timeStamp=nowTime;
				var fd = new FormData();
				var buffer = audioData.getPureWavData(0);         
				fd.set('file', buffer);
				window.aiDialog.voiceToText(fd);
		   }
		    
        };  
  
    };  
    //抛出异常  
    Recorder.throwError = function (message) {  
        throw new function () { this.toString = function () { return message; };};  
    };  
    //是否支持录音  
    Recorder.canRecording = (navigator.getUserMedia != null);  
    //获取录音机  
    Recorder.get = function (callback, config) {  
        if (callback) {  
            if (navigator.getUserMedia) {  
                navigator.getUserMedia(  
                    { audio: true } //只启用音频  A
                    , function (stream) {  //stream这个参数是麦克风的输入流，将这个流传递给Recorder
                        var rec = new Recorder(stream, config);  
                        callback(rec);  
                    }  
                    , function (error) {  
                        switch (error.code || error.name) {  
                            case 'PERMISSION_DENIED':  
                            case 'PermissionDeniedError':  
                                Recorder.throwError('用户拒绝提供信息。');  
                                break;  
                            case 'NOT_SUPPORTED_ERROR':  
                            case 'NotSupportedError':  
                                Recorder.throwError('浏览器不支持硬件设备。');  
                                break;  
                            case 'MANDATORY_UNSATISFIED_ERROR':  
                            case 'MandatoryUnsatisfiedError':  
                                Recorder.throwError('无法发现指定的硬件设备。');  
                                break;  
                            default:  
                                Recorder.throwError('无法打开麦克风。异常信息:' + (error.code || error.name));  
                                break;  
                        }  
                    });  
            } else {  
                Recorder.throwErr('当前浏览器不支持录音功能。'); return;  
            }  
        }  
    };  
    window.Recorder = Recorder;  
})(window);  




// WEBPACK FOOTER //
// ./src/aiDialog/js/aiDialog.js